import store from '@/store';

let ws = null; // WebSocket 实例
let reconnectAttempts = 0; // 重连次数
let reconnectTimer = null; // 重连定时器
const MAX_ATTEMPTS = 10; // 最大重连次数
let intentionalClose = false; // 是否主动断开连接
let messageHandler = null; // 消息处理函数

// 根据 API 地址构建 WebSocket URL
function getWsUrl(token) {
  const baseApi = process.env.VUE_APP_BASE_API || '';
  let host;
  let protocol;

  if (baseApi.startsWith('http://') || baseApi.startsWith('https://')) {
    // 测试环境
    return `wss://testenv-api.carbonneutrality-group.com:8445/carboncore/ws/messages?token=${encodeURIComponent(token)}`;
  } else {
    // 生产环境
    host = window.location.host;
    protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

    return `${protocol}//${host}/carboncore/ws/messages?token=${encodeURIComponent(token)}`;
  }
}

// 建立站内信 WebSocket 连接
export function connectNoticeWebSocket(onMessage) {
  const token = store.state.token;
  if (!token) return;

  messageHandler = onMessage;
  disconnectNoticeWebSocket(false);
  intentionalClose = false;

  try {

    ws = new WebSocket(getWsUrl(token));
    console.log('站内信 WebSocket 连接成功');
    ws.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        data = { content: event.data };
      }
      if (messageHandler) {
        messageHandler(data);
      }
    };

    ws.onclose = () => {
      console.log('站内信 WebSocket 连接关闭');
      ws = null;
      // 非主动断开且仍登录时自动重连
      if (!intentionalClose && store.state.token) {
        reconnectAttempts++;
        if (reconnectAttempts >= MAX_ATTEMPTS) {
          console.log('站内信 WebSocket 重连次数超过最大值，不再重连');
          return;
        }
        reconnectTimer = setTimeout(() => {
          connectNoticeWebSocket(messageHandler);
        }, 10000);
      }
    };

    ws.onerror = () => {
      console.log('站内信 WebSocket 连接错误');
      if (ws) {
        ws.close();
      }
    };
  } catch (error) {
    console.error('站内信 WebSocket 连接失败:', error);
  }
}

// 断开 WebSocket 连接
export function disconnectNoticeWebSocket(intentional = true) {
  intentionalClose = intentional;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  if (ws) {
    ws.close();
    ws = null;
  }
  if (intentional) {
    messageHandler = null;
  }
}
